var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"h-full"},[_c('div',{staticClass:"rounded bg-white"},[_c('div',[_c('extDoogDoor')],1),_c('div',{staticClass:"mt-8"},[_c('edd-sales-pie-chart')],1),_c('div',{staticClass:"mt-8"},[_c('geography-chart')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }